export default __webpack_public_path__ + "static/media/bootstrap_dark.09748ddd.svg";